import { useLazyGetLocationsListQuery } from "app/services/api/locationsApi";
import { LocationModel } from "app/services/api/types/authorisation/models/LocationModel";
import { useEffect, useMemo } from "react";
import { formatEnumText } from "ui/utils/nameUtil";
import { useSelector } from "react-redux";
import { RootState } from "app/services/store";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export function useLocationsListing() {
  const [getLocationsList, { data: locationData, isLoading }] =
    useLazyGetLocationsListQuery();
  const { checkPermission } = usePermissionCheck();

  const userLocations = useSelector(
    (state: RootState) => state.authorisation?.user?.locations,
  );

  const locationOptions = useMemo(() => {
    return (
      locationData?.map((location: LocationModel) => ({
        value: location.id,
        label: formatEnumText(location.name),
      })) ||
      userLocations?.map((location: LocationModel) => ({
        value: location.id,
        label: formatEnumText(location.name),
      })) ||
      []
    );
  }, [locationData, userLocations]);

  useEffect(() => {
    if (!userLocations || !checkPermission(PermissionsEnums.LOCATIONS_LIST)) {
      return;
    }
    getLocationsList();
  }, [userLocations, getLocationsList]);

  return {
    locationData,
    locationOptions,
    isLoading,
    getLocationsList,
  };
}
